import Code, { Categories, postCodeData } from "app/models/code"

export enum Types {
  GET = "CODES_GET",
  GET_SUCCESS = "CODES_GET_SUCCESS",
  GET_FAIL = "CODES_GET_FAIL",
  POST = "CODES_POST",
  POST_SUCCESS = "CODES_POST_SUCCESS",
  POST_FAIL = "CODES_POST_FAIL",
  DELETE = "CODES_DELETE",
  DELETE_SUCCESS = "CODES_DELETE_SUCCESS",
  DELETE_FAIL = "CODES_DELETE_FAIL",
  PATCH = "CODE_PATCH",
  PATCH_SUCCESS = "CODE_PATCH_SUCCESS",
  PATCH_FAIL = "CODE_PATCH_FAIL",
  PATCH_ORDER = "CODE_PATCH_ORDER",
  PATCH_ORDER_SUCCESS = "CODE_PATCH_ORDER_SUCCESS",
  PATCH_ORDER_FAIL = "CODE_PATCH_ORDER_FAIL",
}

export type Action =
  | GetCodesAction
  | GetCodesSuccessAction
  | GetCodesFailAction
  | PostCodesAction
  | PostCodesFailAction
  | PostCodesSuccessAction
  | DeleteCodesByIdAction
  | DeleteCodesByIdFailAction
  | DeleteCodesByIdSuccessAction
  | PatchCodesAction
  | PatchCodesFailAction
  | PatchCodesSuccessAction
  | PatchCodeOrderAction
  | PatchCodeOrderFailAction
  | PatchCodeOrderSuccessAction

export type GetCodesAction = {
  type: Types.GET
}

export type GetCodesSuccessAction = {
  payload: { data: Code[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetCodesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type PostCodesAction = {
  payload: { data: postCodeData }
  type: Types.POST
}

export type PostCodesSuccessAction = {
  type: Types.POST_SUCCESS
  payload: { data: Code }
}

export type PostCodesFailAction = {
  payload: { errors: object }
  type: Types.POST_FAIL
}

export type DeleteCodesByIdAction = {
  payload: { id: string }
  type: Types.DELETE
}

export type DeleteCodesByIdSuccessAction = {
  type: Types.DELETE_SUCCESS
}

export type DeleteCodesByIdFailAction = {
  payload: { errors: object }
  type: Types.DELETE_FAIL
}

export type PatchCodesAction = {
  type: Types.PATCH
  payload: { data: Code }
}

export type PatchCodesSuccessAction = {
  type: Types.PATCH_SUCCESS
  payload: { data: Code }
}

export type PatchCodesFailAction = {
  type: Types.PATCH_FAIL
  payload: { errors: object }
}

export type PatchCodeOrderAction = {
  type: Types.PATCH_ORDER
  payload: { id: number; order: number; category: Categories }
}

export type PatchCodeOrderSuccessAction = {
  type: Types.PATCH_ORDER_SUCCESS
}

export type PatchCodeOrderFailAction = {
  type: Types.PATCH_ORDER_FAIL
  payload: { errors: object }
}

export function getCodes(): GetCodesAction {
  return {
    type: Types.GET,
  }
}

export function getCodesSuccess(data: Code[] | undefined): GetCodesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getCodesFail(errors: object): GetCodesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function deleteCodesById(id: string): DeleteCodesByIdAction {
  return {
    payload: { id },
    type: Types.DELETE,
  }
}

export function deleteCodesByIdSuccess(): DeleteCodesByIdSuccessAction {
  return {
    type: Types.DELETE_SUCCESS,
  }
}

export function deleteCodesByIdFail(errors: object): DeleteCodesByIdFailAction {
  return {
    payload: { errors },
    type: Types.DELETE_FAIL,
  }
}

export function postCodes(data: postCodeData): PostCodesAction {
  return {
    payload: { data },
    type: Types.POST,
  }
}

export function postCodesSuccess(data: Code): PostCodesSuccessAction {
  return {
    payload: { data },
    type: Types.POST_SUCCESS,
  }
}

export function postCodesFail(errors: object): PostCodesFailAction {
  return {
    payload: { errors },
    type: Types.POST_FAIL,
  }
}

export function patchCodes(data: Code): PatchCodesAction {
  return {
    payload: { data },
    type: Types.PATCH,
  }
}
export function patchCodesSuccess(data: Code): PatchCodesSuccessAction {
  return {
    payload: { data },
    type: Types.PATCH_SUCCESS,
  }
}
export function patchCodesFail(errors: object): PatchCodesFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_FAIL,
  }
}

export function patchCodeOrder(id: number, order: number, category: Categories): PatchCodeOrderAction {
  return {
    payload: { id, order, category },
    type: Types.PATCH_ORDER,
  }
}

export function patchCodeOrderSuccess(): PatchCodeOrderSuccessAction {
  return {
    type: Types.PATCH_ORDER_SUCCESS,
  }
}
export function patchCodeOrderFail(errors: object): PatchCodeOrderFailAction {
  return {
    payload: { errors },
    type: Types.PATCH_ORDER_FAIL,
  }
}
